export enum PERIOD_SELECT {
    ONE_YEAR = '1Y',
    SIX_MONTHS = '6M',
    THREE_MONTHS = '3M',
    ONE_MONTH = '1M',
    ONE_WEEK = '1W',
}
